<template>
  <pop-up-layout
    :title="localization.title"
    :description="localization.subtitle"
    :loading="loading"
    :saving="waitingForLoad"
    :disabled="!cambiado"
    @volver="$parent.hide()"
  >
    <Alerts></Alerts>
    <v-col cols="12">
      <v-row justify="center" align="center">
        <v-col cols="12" md="6">
          <v-text-field
            v-model="search" id="search"
            :label="localization.buscar"
          />
        </v-col>
        <v-col cols="12" md="4" lg="3">
          <v-btn
            v-if="!inmueblesEspeciales"
            color="primary"
            @click="cambiarInmuebles()"
          >
            {{localization.inmueblesEspeciales}}
          </v-btn>
          <v-btn
            v-if="inmueblesEspeciales"
            color="primary"
            @click="cambiarInmuebles()"
          >
            {{localization.inmuebles}}
          </v-btn>
        </v-col>
        <v-col cols=11>
          <p class="info-tooltip" v-if="inmueblesEspeciales">
            {{$t('popUpSeleccionarInmueble.mostrando', {item: localization.inmueblesEspeciales})}}
          </p>
          <p class="info-tooltip" v-if="!inmueblesEspeciales">
            {{$t('popUpSeleccionarInmueble.mostrando', {item: localization.mostrandoTodos + ' ' + localization.inmuebles})}}
          </p>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" style="margin-bottom: -20px;">
        <v-col cols="8"></v-col>
        <v-col cols="3">
          <v-checkbox
            v-model="seleccionarTodosMunicipios" id="seleccionarTodosMunicipios"
            clearable
            :label="localization.seleccionarTodosMunicipios"
            hide-details
            @change="seleccionarDeseleccionarTodosMunicipios()"
          />
        </v-col>
      </v-row>
      <v-row justify="center" align="center">
        <v-col cols="8">
          <v-checkbox
            v-model="seleccionarTodosInmuebles" id="seleccionarTodosInmuebles"
            :label="localization.seleccionarTodosInmuebles"
            color="primary"
            hide-details
            @change="seleccionarDeseleccionarTodosInmuebles()"
          />
        </v-col>
        <v-col cols="3">
          <v-autocomplete
            :no-data-text="$t('sinDatos')"
            v-model="poblacionFilter" id="poblacionFilter"
            :items="poblacionesInmuebles"
            multiple
            clearable
            :label="localization.segunLista"
          />
        </v-col>
      </v-row>
      <v-row justify="center" v-if="!inmueblesEspeciales" class="px-6">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :search="search"
            :items="inmueblesPorPromo"
            @current-items="filtrados"
            item-key="inmuebleId"
            :footer-props="{
              'items-per-page-text': $t('filasPorPagina'),
              'items-per-page-options': [5, 10, 15, 20]
            }"
            :items-per-page="5"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.inmuebleId"
                  @click="seleccionarInmueble(item)"
                  :style="selected.some(x => (x.inmuebleId === item.inmuebleId && x.inmuebleEspecialId === item.inmuebleEspecialId)) ? 'background-color: lightgray' : ''"
                >
                  <td class="text-xs-left">{{ item.cliente }}</td>
                  <td class="text-xs-left" v-html="item.nomInmueble" ></td>
                  <td class="text-xs-center">{{ item.direccion }}</td>
                  <td class="text-xs-center">{{ item.poblacion }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row justify="center" v-else class="px-6">
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :search="search"
            :items="inmueblesEspecialesPorPromo"
            @current-items="filtrados"
            item-key="inmuebleEspecialId"
            :footer-props="{
              'items-per-page-text': $t('filasPorPagina'),
              'items-per-page-options': [5, 10, 15, 20]
            }"
            :items-per-page="5"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.inmuebleEspecialId"
                  @click="seleccionarInmueble(item)"
                  :style="selected.some(x => x.inmuebleEspecialId === item.inmuebleEspecialId) ? 'background-color: lightgray' : ''"
                >
                  <td class="text-xs-center">{{ item.cliente }}</td>
                  <td class="text-xs-center">{{ traducirInmEspecial(item) }}</td>
                  <td class="text-xs-center">{{ traducirInmEspecial(item) }}</td>
                  <td class="text-xs-center">{{ item.poblacion }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row justify="center" align="center" v-if="multiple">
        <v-btn
          color="primary"
          @click="confirmar()"
        >
          {{localization.confirmButton}}
        </v-btn>
      </v-row>
    </v-col>

  </pop-up-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/components/generic/rules.js'
import Alerts from '@/components/Alerts'

export default {
  components: {
    Alerts
  },
  mixins: [rulesMixin],
  props: {
    promoId: {
      type: Array,
      required: true
    },
    yaSeleccionado: {
      type: Array,
      default: () => []
    },
    multiple: {
      type: Boolean,
      default: false
    },
    especiales: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      waitingForLoad: false,
      loading: false,
      inmueblesEspeciales: false,
      search: null,
      selected: null,
      items: [],
      seleccionarTodosInmuebles: false,
      poblacionFilter: [],
      seleccionarTodosMunicipios: false,
      itemsFiltrados: []
    }
  },
  async created () {
    try {
      this.loading = true
      await this.getPropertiesByStringAndPropertyDevId(this.promoId)
      await this.getInmueblesEspecialesByStringAndIdPromocion(this.promoId)
      this.inmueblesEspeciales = this.especiales
      if (!this.inmueblesEspeciales) {
        this.selected = this.yaSeleccionado.length !== 0 ? this.inmueblesPorPromo.filter(x => {
          return this.yaSeleccionado.some(y => {
            if (y.inmuebleId !== null) {
              return x.inmuebleId === y.inmuebleId
            } else if (y.inmuebleId === null) {
              return x.inmuebleEspecialId === y.inmuebleEspecialId
            }
          })
        }) : []
      } else {
        this.selected = this.yaSeleccionado.length !== 0 ? this.inmueblesEspecialesPorPromo.filter(x => {
          return this.yaSeleccionado.some(y => x.inmuebleEspecialId === y.inmuebleEspecialId)
        }) : []
      }
      this.loading = false
    } catch (error) {
      this.addAlert({ texto: this.$t('errorCargarInmuebles'), color: 'error' })
    }
  },
  computed: {
    ...mapGetters({
      getConfiguracion: 'configuracion/getConfiguracion'
    }),
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    localization () {
      return this.$t('popUpSeleccionarInmueble')
    },
    headers () {
      return [
        {text: this.localization.headerCliente, value: 'cliente', sortable: true, align: 'LEFT'},
        {text: this.localization.headerInmueble, value: 'nomInmueble', sortable: true, align: 'LEFT'},
        {text: this.localization.headerDireccion, value: 'direccion', sortable: true, align: 'LEFT'},
        {text: this.localization.headerPoblacion, value: 'poblacion', sortable: true, align: 'LEFT'}
      ]
    },
    inmueblesPorPromo () {
      if (this.$store.state.incidencias.propertiesByStringAndPropDevId) {
        let inm = this.$store.state.incidencias.propertiesByStringAndPropDevId
        if ( this.poblacionFilter.length > 0 ) {
          let aux = []
          inm.forEach(item => {
              if ( this.poblacionFilter.includes(item.poblacion) === true ) {
                aux.push(item)
              }
            })
          return aux
        }
        else {
          return [...new Map(inm.map(item => [item['inmuebleId'], item])).values()]
        }
      }
      return []
    },
    inmueblesEspecialesPorPromo () {
      if (this.$store.state.incidencias.inmueblesEspecialesByStringAndIdPromocion) {

        //** Filtramos los inmuebles especiales duplicados */
        let listaInmueblesEspe = []
        let listaAux = this.$store.state.incidencias.inmueblesEspecialesByStringAndIdPromocion
        listaAux.forEach(item => {
          if(item.promocionId === null){
            listaInmueblesEspe.push(item)
          }else{
            let duplicado = false
            listaAux.forEach(item2 => {
              if(item2.promocionId === null){
                if(item.idEspecial == item2.idEspecial){
                  duplicado = true
                }
              }
            })
            if(!duplicado){
              listaInmueblesEspe.push(item)
            }
          }
        })
        /** Fin */

        if ( this.poblacionFilter.length > 0 ) {
          let inm = listaInmueblesEspe //this.$store.state.incidencias.inmueblesEspecialesByStringAndIdPromocion
          let aux = []
          inm.forEach(item => {
              if ( this.poblacionFilter.includes(item.poblacion) === true ) {
                aux.push(item)
              }
            })
          return aux
        }
        else {
          return listaInmueblesEspe //this.$store.state.incidencias.inmueblesEspecialesByStringAndIdPromocion
        }
      }
      return []
    },
    poblacionesInmuebles () {
      let inmuebles = []
      let aux = []
      if ( this.inmueblesEspeciales === true ) {
        if ( this.$store.state.incidencias.inmueblesEspecialesByStringAndIdPromocion != null) {
          inmuebles = this.$store.state.incidencias.inmueblesEspecialesByStringAndIdPromocion
        }
      }
      else {
        if ( this.$store.state.incidencias.propertiesByStringAndPropDevId != null) {
          inmuebles = this.$store.state.incidencias.propertiesByStringAndPropDevId
        }
      }
      if ( inmuebles.length > 0 ) {
        inmuebles.forEach(inmueble => {
          if ( inmueble.poblacion !== null && inmueble.poblacion.trim() !== "") {
            aux.push(inmueble.poblacion)
          }
        })
      }

      return aux
    },
    cambiado () {
      return this.yaSeleccionado !== this.selected
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getPropertiesByStringAndPropertyDevId: 'incidencias/getPropertiesByStringAndPropertyDevId',
      getInmueblesEspecialesByStringAndIdPromocion: 'incidencias/getInmueblesEspecialesByStringAndIdPromocion'
    }),
    cambiarInmuebles () {
      this.selected = []
      this.inmueblesEspeciales = !this.inmueblesEspeciales
    },
    seleccionarInmueble (inmueble) {
      const alquiler = this.getConfiguracion.tiposIncidenciaAlquiler
      const sinOperacion = this.getConfiguracion.tiposIncidenciaSinOperacion
      const venta = this.getConfiguracion.tiposIncidenciaVenta

      /** 421427 - Al seleccionar un inmueble para introducir una visita, figura error al no tener definida la tipología de visita. */
      if(
        (inmueble.ambito === 0 && sinOperacion.length <= 0) ||
        (inmueble.ambito === 1 && venta.length <= 0) ||
        (inmueble.ambito === 2 && alquiler.length <= 0)
      ) {
        this.addAlert({texto: this.$t('noExistenTiposVisitaAsociadosInmueble'), color: 'error'})      
      } else {
        if (this.multiple) {
          // if (this.selected.includes(inmueble)) {
          if (this.selected.some(x => {
            if (x.inmuebleId !== null) {
              return x.inmuebleId === inmueble.inmuebleId
            } else if (x.inmuebleId === null) {
              return x.inmuebleEspecialId === inmueble.inmuebleEspecialId
            }
          })) {
            let index = this.selected.indexOf(inmueble)
            this.selected.splice(index, 1)
          } else {
            this.selected.push(inmueble)
          }
        } else {
          this.$emit('selected', inmueble)
          this.$parent.hide()
        }
      }
    },
    confirmar () {
      this.$emit('selected', this.selected)
      if (this.selected.length === 0) {
        this.inmueblesEspeciales = false
      }
      this.$emit('empezar', this.inmueblesEspeciales)
      this.$parent.hide()
    },
    seleccionarDeseleccionarTodosMunicipios () {
        let municipios = []
        if (this.seleccionarTodosMunicipios === true) {
            this.poblacionFilter = []
            municipios = this.poblacionesInmuebles
            municipios.forEach(municipio => {
              if ( this.poblacionFilter.includes(municipio) === false ) {
                this.poblacionFilter.push(municipio)
              }
            });
        }
        else {
            this.poblacionFilter = []
        }
    },
    seleccionarDeseleccionarTodosInmuebles () {
      let inmuebles = []
      // inmueblesEspecialesPorPromo
      if (this.seleccionarTodosInmuebles === true) {
          this.selected = []
          if(this.inmueblesEspeciales)
            inmuebles = this.inmueblesEspecialesPorPromo;
          else 
            inmuebles = this.inmueblesPorPromo;

          inmuebles.forEach(inmueble => {
            if(
              this.campoCumpleBusqueda(inmueble.cliente) ||
              this.campoCumpleBusqueda(inmueble.direccion) ||
              this.campoCumpleBusqueda(inmueble.nomInmueble) ||
              this.campoCumpleBusqueda(inmueble.poblacion) ||
              this.campoCumpleBusqueda(inmueble.uhedit)
            ) {
              this.selected.push(inmueble)
              // this.selected.push(inmueble)
            }
              
          });
      }
      else {
          this.selected = []
      }
    },
    campoCumpleBusqueda (campo) {
      if(campo === null) return false
      if(this.search === null || this.search === '') return true
      
      if(campo.toLowerCase().includes(this.search.toLowerCase()))
        return true
      else
        return false
    },
    filtrados(e) {
      this.itemsFiltrados = e;
    },
    traducirInmEspecial(item) {
      if(this.usuario.idioma === 'spa') {
        return item.nomInmueble
      } else {
        let traducciones = JSON.parse(item.traduccion)
        if(traducciones) {
          return traducciones[this.usuario.idioma] || item.nomInmueble
        } else {
          return item.nomInmueble
        } 
      }
    }
  }
}
</script>

<style scoped>

  td {
    white-space: pre-wrap
  }
  .info-tooltip {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.54);
    font-weight: bold;
    margin-bottom: 0px;
  }
</style>
